import React from 'react';

function Hidden(props) {
	let {
		name = '',
		required = false,
		updateItem = () => {
		},
		item = {}
	} = props;


	return (
		<input
			type="hidden"
			className="form-control"
			value={typeof item[name] !== 'undefined' ? item[name] : ''}
			onChange={(evt) => {
				updateItem(name, evt.target.value);
			}}
			/*required*/
		/>
	);
}

export default Hidden;
